import { CartContext } from 'constants/contexts';
import React, { useContext } from 'react';
import { Divider, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import Skeleton from 'components/Skeleton';
import ItemCard from 'components/ItemCard';
import { getCategoryHeaderId } from './utils';

function Categories({
  categories, disabled, empty,
}) {
  const { getQty } = useContext(CartContext);
  if (categories.length === 0 && empty) {
    return empty;
  }
  return categories.map((cat, index) => (
    <Grid
      key={cat.id || index}
      container
      spacing={{ xs: 0, md: 2 }}
      mb={3}
      sx={{
        filter: disabled ? 'grayscale(1)' : undefined,
        opacity: disabled ? 0.5 : 1,
        px: {
          xs: 2,
          md: 4,
        },
      }}
    >
      <Grid size={12} mt={4}>
        <Typography variant="title-md" id={getCategoryHeaderId(index)}>
          {cat.name}
        </Typography>
      </Grid>
      {cat.items
        .sort((a, b) => getQty(b.id) - getQty(a.id))
        .map((item, i) => (
        <Grid size={{ xs: 12, lg: 6, xl: 4 }} key={item.id || i}>
          <ItemCard
            item={item}
          />
          <Divider sx={{ m: 0, display: { xs: 'block', md: 'none' } }} />
        </Grid>
      ))}
    </Grid>
  ));
}

function CategoriesSkeleton() {
  return (
    <Skeleton
      sx={{
        px: {
          xs: 2,
          md: 4,
        },
      }}
    >
      <Grid container spacing={2} mb={3}>
        <Grid size={12} mt={4}>
          <Typography variant="h5">
            {Skeleton.props.string()}
          </Typography>
        </Grid>
        {(Array.from(new Array(10))).map((_, index) => (
          <Grid size={{ xs: 12, md: 6, xl: 4 }} key={index}>
            <ItemCard loading />
          </Grid>
        ))}
      </Grid>
    </Skeleton>
  );
}

export default Skeleton.withSkeleton(Categories, CategoriesSkeleton);
